import api from "./api";

export interface GeoJSONFeature {
  type: "Feature";
  geometry: {
    type: "Point";
    coordinates: [number, number];
  };
  properties: {
    fecha: string;
    biomasa: number;
    categoria: string;
    nasc_total: number;
    bati: number;
    color: string;
  };
}

export interface GeoJSONCollection {
  type: "FeatureCollection";
  features: GeoJSONFeature[];
  metadata?: {
    map_type: "point" | "transect";
    generated_at: string | null;
    data_start: string | null;
    data_end: string | null;
    feature_count: number;
    biomass_total: number;
    pipeline_start_date: string | null;
  };
}

export interface PipelineStatus {
  status: string;
  last_run: string | null;
  last_error: string | null;
  records_processed: number;
  data_start?: string | null;
  data_end?: string | null;
  artifacts_generated_at?: string | null;
}

/**
 * Fetch GeoJSON biomass data for the map.
 * @param mapType - 'point' for biomass by point, 'transect' for biomass by transect
 */
export const getMapGeoJSON = async (mapType: "point" | "transect"): Promise<GeoJSONCollection> => {
  // This goes through Go backend which proxies to Python service
  const response = await api.get(`/map/geojson/${mapType}`);
  return response.data;
};

/**
 * Trigger the data pipeline manually.
 */
export const runPipeline = async () => {
  const response = await api.post("/map/pipeline/run");
  return response.data;
};

/**
 * Get pipeline execution status.
 */
export const getPipelineStatus = async (): Promise<PipelineStatus> => {
  const response = await api.get("/map/pipeline/status");
  return response.data;
};
